import noticeError from "src/app/utilities/noticeError";
import { addPageAction } from "src/utilities/newrelic";
import getQueryParamValue from "src/utilities/getQueryParamValue";

export const setChatWidgetParam = () => {
  if (typeof window !== "undefined") {
    const url = new URL(window.location.href);
    url.searchParams.set("showChatWidget", "true");
    window.history.replaceState({}, "", url.toString());
  }
};

export const deleteChatWidgetParam = () => {
  if (typeof window !== "undefined") {
    const url = new URL(window.location.href);
    url.searchParams.delete("showChatWidget");
    window.history.replaceState({}, "", url.toString());
  }
};

export const sierraChatTimeoutAction = (setShow, setLoadError) => {
  return setTimeout(() => {
    const sierraChatContainer = document.querySelector(
      "#sierra-chat-container"
    );

    const chatBotLoaded =
      sierraChatContainer?.shadowRoot?.querySelector("main") ||
      sierraChatContainer?.shadowRoot?.querySelector("section");

    if (chatBotLoaded) {
      addPageAction("sierra_chat_loaded");
    } else if (getQueryParamValue("showChatWidget")) {
      deleteChatWidgetParam();
      const timeoutError = new Error("Sierra Chat: Timeout error");
      noticeError(timeoutError);
      setShow(false);
      setLoadError(timeoutError);
    }
  }, 5000);
};
